<div class="md2-tooltip" [style.transform-origin]="_transformOrigin" [@state]="_visibility" (@state.done)="_afterVisibilityAnimation($event)" [innerHTML]="message"></div>


// WEBPACK FOOTER //
// ./node_modules/md2/tooltip/tooltip.html